<template>
  <div id="app">
    <Header routeValue="4" ref="header"></Header>
    <content class="content-help">
      <div class="banner_box">
        <div class="search_section">
          <div class="search_title">Printbelle Help Center</div>
          <span>
            <a-input
              style="width: 693px"
              placeholder="Search for answers"
              @pressEnter="onSearch"
              allow-clear>
              <a-icon slot="prefix" type="search"/>
            </a-input>
          </span>
        </div>
      </div>
      <div class="content_container">
        <a class="view_box" v-for="item in dataList" :href="item.prefix + item.link">
          <div class="title">{{ item.name }}</div>
          <div class="subhead">{{ item.remark }}</div>
          <div class="divider"></div>
          <div class="more">
            See all articles
            <img class="img" src="@/assets/icon/arrow1.png">
          </div>
        </a>
      </div>

    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import {get} from '@/api'
import {getSeoLinkName} from '@/utils/utils'

export default {
  name: 'Index',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      baseUrl: process.env.VUE_APP_MERCHANT,
      dataList: []
    }
  },
  mounted () {
    window.scrollTo({top: 0, behavior: 'smooth'})
  },
  created () {
    this.listHelpIndex()
  },
  methods: {
    getSeoLinkName,
    listHelpIndex () {
      get('/merchant/message/help/index')
        .then(response => {
          this.dataList = response.data
          this.dataList.forEach(item => {
            item.link = getSeoLinkName(item.name)
            item.prefix = '/help/list/'
          })
        }).catch(error => {
        console.error(error)
      })

    },
    handleToPage (item) {
      let index = getSeoLinkName(item.name)
      let encodedPath = encodeURIComponent(index)
      this.$router.push({path: encodedPath})
    },
    onSearch (row) {
      window.location.href = `/help/search-results?term=${row.target.value}`
    },
  }
}
</script>
<style scoped lang="less">

.content-help {
  width: 100%;
  display: flex;
  min-height: 800px;
  flex-direction: column;
  background: #FFFFFF;

  .banner_box {
    height: 450px;
    //margin-top: 72px;
    background-image: url(../assets/icon/help_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;

    .search_section {
      width: 693px;
      display: flex;
      flex-direction: column;
      margin-left: 425px;
      margin-top: 235px;

      .search_title {
        font-family: IBM Plex Sans;
        font-weight: bold;
        font-size: 50px;
        color: #FFFFFF;
        line-height: 50px;
        margin-bottom: 18px;
      }

      /deep/ .ant-input {
        height: 50px;
        border-radius: 4px;
        font-size: 15px;
        font-weight: 400;
        background: #FFFFFF;
      }
    }
  }

  .content_container {
    position: relative;
    width: 100%;
    max-width: 1080px;
    margin: 55px auto !important;
    float: none !important;
    display: flex;
    flex-wrap: wrap;

    .view_box {
      width: 326px;
      height: 200px;
      margin: 17px;
      background: #FFFFFF;
      padding: 36px 38px 17px 38px;
      transition: box-shadow 0.3s;
      border-left: 3px solid #302D7E;
      box-shadow: 2px 0px 6px 0px rgba(7, 7, 7, 0.05);

      .title {
        font-weight: 500;
        font-size: 22px;
        color: #33475B;
        line-height: 28px;
        overflow: hidden; // 超出的文本隐藏
        text-overflow: ellipsis; // 溢出用省略号显示
        white-space: nowrap;
      }

      .subhead {
        font-weight: 400;
        font-size: 14px;
        height: 73px;
        margin-top: 10px;
        color: #516F90;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }

      .more {
        font-weight: 400;
        height: 40px;
        display: flex;
        align-items: center;
        border-top: 1px solid #EAF0F6;
        font-size: 12px;
        margin-top: 11px;
        color: #516F90;

        .img {
          margin-left: 10px;
          margin-top: 2px;
        }
      }
    }

    .view_box:hover {
      box-shadow: 2px 0px 6px 0px rgba(7, 7, 7, 0.25);
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/views/HelpCenter.vue